import { useState } from 'react';
import { toast } from 'react-toastify';
import http from '@core/fetch';

export type MacExportFormat = 'pptx' | 'png';

export function useMacExport() {
    const [downloadingIds, setDownloadingIds] = useState<number[]>([]);

    const exportMac = async (id: number, format: MacExportFormat) => {
        setDownloadingIds((ids) => [...ids, id]);
        try {
            await http.downloadFileXHR('get', 'macs export', { id, format });
            toast.success('File has been downloaded');
        } catch {
            toast.error('Error while downloading file');
        } finally {
            setDownloadingIds((ids) => ids.filter((currentId) => currentId !== id));
        }
    };

    return { downloadingIds, exportMac };
}
